import { useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../api-config';
import { handleAuthError } from './ValidateToken';
import { useNavigate } from 'react-router-dom';

const usePreloadNextChapter = ({
  isCurrentChapterLoaded,
  currentChapterIndex,
  isLoadingCurrentChapter,
  capitulos,
  audiolibroId,
  usuarioId,
  token,
  loadedChapters,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    let timeoutId;

    if (
      isCurrentChapterLoaded &&
      currentChapterIndex &&
      !isLoadingCurrentChapter
    ) {
      const nextChapterIndex = currentChapterIndex + 1;

      if (
        nextChapterIndex <= capitulos.length &&
        !loadedChapters.current[nextChapterIndex]
      ) {
        timeoutId = setTimeout(() => {
          preloadChapter(nextChapterIndex);
        }, 5000);
      }
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    isCurrentChapterLoaded,
    currentChapterIndex,
    isLoadingCurrentChapter,
    capitulos,
    audiolibroId,
    token,
  ]);

  const preloadChapter = async (nextChapterIndex) => {
    const nextAudioUrl = `${API_URL}/stream-audio-simple/${usuarioId}/${audiolibroId}/${nextChapterIndex}`;
    try {
      const response = await axios.get(nextAudioUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      const audioBlob = new Blob([response.data], { type: 'audio/mpeg' });
      const audioUrlWithToken = URL.createObjectURL(audioBlob);

      loadedChapters.current[nextChapterIndex] = audioUrlWithToken;
    } catch (error) {
      console.error(`Error al precargar la pista ${nextChapterIndex}:`, error);
      handleAuthError(error, navigate);
    }
  };
};

export default usePreloadNextChapter;
